(function($, undefined) {

	'use strict';
    var catalogProductsAutocomplete;
    var catalogProductsChoiceRemove;

    var fetchCatalogProducts = function(){
        var t = $(this);
        var parent = t.closest(".catalog-products-autocomplete-results");
        var dropdown = parent.find(".catalog-products-results-ctn");
        var input = parent.find(".catalog-products-autocomplete-results-choice");
        var val = t.val();
        
        var arr = input.val().split(",");
        if(val.length > 2){
            ajax("/action/ajaxGetProduct?name=" + val, function (response, e) {
                dropdown.empty();
                var json = JSON.parse(response.trim());
                $.each(json, function (k, v) {
                    var cl = "";
                    if(arr.indexOf(String(json[k].productId)) !== -1){
                        cl = " pmi-autocomplete-catalog-product-name-added";
                    }
                    var el = $("<div class='pmi-autocomplete-catalog-product-name" + cl + "' data-id='" + json[k].productId + "'></div>").text(json[k].name);
                    dropdown.append(el);
                });
                dropdown.slideDown();
                dropdown.find(".pmi-autocomplete-catalog-product-name:not('.pmi-autocomplete-catalog-product-name-added')").on("click", selectCatalogProduct);
            }, true);
        }
    };
    
    var selectCatalogProduct = function(){
        var t = $(this);
        var id = t.attr("data-id");
        var name = t.text();
        var parent = t.closest(".catalog-products-autocomplete-results");
        var tags = parent.find(".catalog-products-results-tag-ctn");
        var input = parent.find(".catalog-products-autocomplete-results-choice");

        var inputVal = input.val();

        var arr = inputVal.split(",");
        if (arr.indexOf(id) === -1) {
            arr.push(id);
            var el = $("<div class='pmi-autocomplete-catalog-product-name-tags' data-id='" + id + "'></div>");
            var el2 = "<span class='pmi-remove-tag'>X</span>";
            var el3 = "<span>" + name + "</span>";
            el.append(el3);
            el.append(el2);
            el.on("click", removeSelectedCatalogProducts);
            tags.append(el);
            t.addClass("pmi-autocomplete-catalog-product-name-added");
            if (tags.not(":visible")) {
                tags.slideDown();
            }
        }

        input.val(arr.join(","));
		var langs = $('html').attr('data-all-langs');
        updateLabelLangs(input.attr("name"), arr.join(","), langs, function() {
			if (t.hasClass('refresh')) {
				window.location.reload();
			}
		}, true);
    };
    
    function removeSelectedCatalogProducts(){
        var t = $(this);
        var id = t.attr("data-id");
        var parent = t.closest(".catalog-products-autocomplete-results");
        var tags = parent.find(".catalog-products-results-tag-ctn");
        var input = parent.find(".catalog-products-autocomplete-results-choice");
        
        var inputVal = input.val();

        var arr = inputVal.split(",");
        if (arr.indexOf(id) !== - 1) {
            arr.splice(arr.indexOf(id), 1);
            if(arr.length === 1){                
                tags.slideUp();
            }
        }
        input.val(arr.join(","));
        t.remove();
        var langs = $('html').attr('data-all-langs');
        updateLabelLangs(input.attr("name"), arr.join(","), langs, function () {
            if (t.hasClass('refresh')) {
                window.location.reload();
            }
        }, true);
    }

	var init = function() {
        
        catalogProductsAutocomplete = $(".catalog-products-featured-pick");
        catalogProductsAutocomplete.on("keyup", fetchCatalogProducts);
        catalogProductsAutocomplete.on("focus", fetchCatalogProducts);
        
        catalogProductsChoiceRemove = $(".pmi-autocomplete-catalog-product-name-tags");
        catalogProductsChoiceRemove.on("click", removeSelectedCatalogProducts);
        
        $(document).on('click', function (catalogProduct) {
            if (!$(catalogProduct.target).closest('.catalog-products-autocomplete-results').length) {
                $(".catalog-products-results-ctn").slideUp();
            }
        });
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

